var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("customerReviewService", [
    "$http",
    function ($http) {
        return {
            getReviewsTableByUserId: function (userId) {
                return $http.get(
                    "storefrontapi/getreviewstablebyuserid?userId=" +
                        userId +
                        "&t=" +
                        new Date().getTime()
                );
            },
            getReviewsByUser: function (userId) {
                return $http.get('storefrontapi/getreviewsbyuserid?userId=' + userId);
            },
            getReviewsCategories: function () {
                return $http.get('storefrontapi/getreviewscategories');
            },
            getCustomerReviewSettings: function () {
                return $http.get('storefrontapi/reviewsettings');
            },
            insertReview: function (review, categories, file) {
                var formdata = new FormData();
                formdata.append('review', angular.toJson(review));
                formdata.append("file", file);
                formdata.append("categories", categories);
                return $http.post('storefrontapi/insertuserreview', formdata, {
                    headers: { 'Content-Type': undefined },
                });
    
            },
            getReviewsByOrder: function (orderId) {
                return $http.get('storefrontapi/customerreviewsbyorderid?oid=' + orderId);
            },
            getCustomerShowcaseBanner : function (count) {
                return $http.get('storefrontapi/customershowcase/bannerimage?count=' + count + '&t=' + new Date().getTime());
            },
            getCustomerShowcaseIndividualRatingCount: function (productId) {
                return $http.get('storefrontapi/customershowcase/individualratingcount?productId=' + productId + '&t=' + new Date().getTime());
            },
            getCustomerShowcaseReviewFilter : function () {
                return $http.get('storefrontapi/customershowcase/filter?t=' + new Date().getTime());
            },
            searchCustomerShowcaseReviews : function (searchCriteria) {
                return $http.post('storefrontapi/customershowcase/search', searchCriteria);
            }
        };
    },
]);
